import { render, staticRenderFns } from "./Stats.vue?vue&type=template&id=08ba4c6e&scoped=true&"
import script from "./Stats.vue?vue&type=script&lang=js&"
export * from "./Stats.vue?vue&type=script&lang=js&"
import style0 from "./Stats.vue?vue&type=style&index=0&id=08ba4c6e&lang=scss&scoped=true&"
import style1 from "./Stats.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ba4c6e",
  null
  
)

export default component.exports